import React from 'react';
import {
  Alert, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction,
  ListItemText, Paper, Typography,
} from '@mui/material';
import { Close as CloseIcon, CloudUpload as UploadIcon, Description as DocumentIcon } from '@mui/icons-material';

const REQUIRED_DOCS = [
  { id: 'license', label: 'Business license', hint: 'Municipal or provincial business license' },
  { id: 'insurance', label: 'Insurance certificate', hint: 'Commercial liability and cargo coverage' },
];

export default function DocumentsStep({ answers, errors, onChange }) {
  const documents = answers.documents;
  const addFiles = e => {
    const files = Array.from(e.target.files || []);
    if (files.length) onChange({ ...answers, documents: [...documents, ...files] });
  };
  const remove = index => onChange({ ...answers, documents: documents.filter((_, i) => i !== index) });

  return (
    <>
      <Typography variant="h5" fontWeight={600} gutterBottom>Documents & verification</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        MOVD reviews these before approving your account. Approval is what makes you bookable.
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, mb: 2.5, borderRadius: 2 }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>REQUIRED</Typography>
        {REQUIRED_DOCS.map(doc => (
          <Typography key={doc.id} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            • <strong>{doc.label}</strong> — {doc.hint}
          </Typography>
        ))}
      </Paper>

      {errors.documents && <Alert severity="error" sx={{ mb: 2 }}>{errors.documents}</Alert>}

      <Paper
        component="label"
        sx={{
          p: 3, border: '2px dashed', borderColor: 'divider', textAlign: 'center',
          cursor: 'pointer', display: 'block', mb: 2,
          '&:hover': { borderColor: 'primary.main', backgroundColor: 'primary.50' },
        }}
      >
        <UploadIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
        <Typography variant="subtitle1" fontWeight={600}>Drop files here or click to browse</Typography>
        <Typography variant="body2" color="text.secondary">PDF, JPG or PNG — max 10MB each</Typography>
        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png" onChange={addFiles} style={{ display: 'none' }} />
      </Paper>

      {documents.length > 0 && (
        <List>
          {documents.map((doc, index) => (
            <ListItem key={`${doc.name}-${index}`}>
              <ListItemIcon><DocumentIcon /></ListItemIcon>
              <ListItemText primary={doc.name} secondary={`${(doc.size / 1024 / 1024).toFixed(2)} MB`} />
              <ListItemSecondaryAction>
                <IconButton edge="end" color="error" onClick={() => remove(index)}><CloseIcon /></IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}
    </>
  );
}
